var map = {
	"./Vision.svg": "f5b4",
	"./bahrain.svg": "d717",
	"./business.svg": "ad86",
	"./climate.svg": "77c8",
	"./customer.svg": "6784",
	"./generaion.svg": "1748",
	"./graduate.svg": "0a9b",
	"./inclusivity.svg": "d381",
	"./iraq.svg": "75ce",
	"./jordan.svg": "84b5",
	"./key.svg": "2f35",
	"./kuwait.svg": "68d7",
	"./mission.svg": "0994",
	"./ngo.svg": "d69d",
	"./online-learning.svg": "09f3",
	"./saudi-arabia.svg": "ca26",
	"./social-chart.svg": "4f18",
	"./social-chart_ar.svg": "b4e4",
	"./socialmedia.svg": "ecd3",
	"./south-sudan.svg": "b8c1",
	"./sudan.svg": "4432",
	"./unicef.svg": "d235"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6699";